import '../../polyfills';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { environment } from '../../environments/environment';
import { AppModule } from '../../app/app.module';
import { hmrBootstrap } from '../../hmr';

if (environment.useProdMode) {
    enableProdMode();
}

// SD-7544: In production, suppress all console output so raw error objects /
// messages / stack traces never reach the browser console (an information-
// disclosure surface). Uncaught errors are still captured — GlobalErrorHandler
// reports them to the backend (POST /client-errors -> Better Stack) and shows
// the user a safe generic message. Bracket access avoids tripping the
// no-console-log lint rule on the suppressor itself.
if (environment.production) {
    const noop = (): void => undefined;
    const consoleRef = console as unknown as Record<string, () => void>;
    for (const method of ['log', 'debug', 'info', 'warn', 'error']) {
        consoleRef[method] = noop;
    }
}

const bootstrap = () => {
    return platformBrowserDynamic().bootstrapModule(AppModule);
};

if (environment.hmr) {
    if (module['hot']) {
        hmrBootstrap(module, bootstrap);
    } else {
        if (!environment.production) {
            console.error('HMR is not enabled for webpack-dev-server!');
            console.log('Are you using the --hmr flag for ng serve?');
        }
    }
} else {
    bootstrap();
}
